import React, { useEffect, useMemo, useState } from 'react';
import PageShell from './PageShell';

const API_BASE = 'https://admin.wealthdost.com/api/pages';

const pickContent = (payload) => {
  if (!payload || typeof payload !== 'object') return { title: null, content: null };

  const direct = payload.content || payload.body || payload.html || payload.description;
  if (direct) return { title: payload.title || null, content: direct };

  if (payload.data && typeof payload.data === 'object') {
    const data = payload.data;
    const dataContent = data.content || data.body || data.html || data.description;
    if (dataContent) return { title: data.title || null, content: dataContent };
  }

  if (payload.page && typeof payload.page === 'object') {
    const page = payload.page;
    const pageContent = page.content || page.body || page.html || page.description;
    if (pageContent) return { title: page.title || null, content: pageContent };
  }

  return { title: null, content: null };
};

const ApiPage = ({ slug, fallbackTitle, seoTitle, seoDescription, seoPath }) => {
  const [state, setState] = useState({ loading: true, error: null, title: null, content: null });

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const res = await fetch(`${API_BASE}/${slug}`);
        if (!res.ok) throw new Error(`Request failed with ${res.status}`);
        const data = await res.json();
        const extracted = pickContent(data);

        if (!isMounted) return;
        setState({
          loading: false,
          error: extracted.content ? null : 'No content returned from API.',
          title: extracted.title,
          content: extracted.content
        });
      } catch (err) {
        if (!isMounted) return;
        setState({ loading: false, error: err.message || 'Failed to load content.', title: null, content: null });
      }
    };

    load();
    return () => {
      isMounted = false;
    };
  }, [slug]);

  const { title, content, loading, error } = state;
  const resolvedTitle = title || fallbackTitle;
  const isHtml = useMemo(() => typeof content === 'string' && content.includes('<'), [content]);

  return (
    <PageShell
      title={resolvedTitle}
      seoTitle={seoTitle || `${resolvedTitle} | WealthDost`}
      seoDescription={seoDescription}
      seoPath={seoPath}
    >
      {loading && <p className="text-[#94A3B8]">Loading...</p>}
      {!loading && error && (
        <p className="text-[#FCA5A5]">{error}</p>
      )}
      {!loading && !error && content && (
        isHtml ? (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          <div className="whitespace-pre-line">{content}</div>
        )
      )}
    </PageShell>
  );
};

export default ApiPage;
